<template>
  <div class="row spinner-parent">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h1>Audio Album</h1>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <strong>Add new Audio Tracks</strong>
          <router-link
            class="btn btn-primary btn-sm pull-right"
            :to="{ name: 'AlbumManageTracks', params: { id: $route.params.id }}"
          >
            Manage Audio Tracks
          </router-link>
        </div>

        <div class="card-block">
          <div class="row images-dd__wrap">
            <div class="col-md-6">
              <div class="images-dd__target-zone">
                <div class="images-dd__target-zone__title">
                  Audio tracks which will add to Audio album:
                </div>
                <div class="images-dd__list">
                  <div
                    v-for="item in selectedTracks"
                    :key="item.id"
                    class="images-dd__item"
                    :data-id="item.id"
                    :title="item.title"
                  >
                    <div class="images-dd__item__img">
                      <img :src="item.thumbnail" alt="">
                    </div>
                    <div class="images-dd__item__title">{{ shortTitle(item.title) }}</div>
                    <div class="images-dd__item__cover" @click="deleteTrack(item)">
                      <i class="fa fa-minus" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="images-dd__source-wrap spinner-parent">
                <div class="images-dd__source-search">
                  <input
                    v-model="searchQuery"
                    type="text"
                    class="form-control"
                    placeholder="Search by audio track title"
                  >
                </div>

                <div class="spinner-parent">
                  <spinner ref="sourceSpinner" size="md" text="Loading ..." />

                  <div class="images-dd__list">
                    <div
                      v-for="item in sourceTracks"
                      :key="item.id"
                      class="images-dd__item"
                      :data-id="item.id"
                    >
                      <div class="images-dd__item__img">
                        <smart-image :src="item.thumbnail" alt="" />
                      </div>
                      <div class="images-dd__item__title" :title="item.title">
                        {{ shortTitle(item.title) }}
                      </div>
                      <div class="images-dd__item__cover" @click="addTrack(item)">
                        <i class="fa fa-plus" />
                      </div>
                    </div>

                    <div v-if="!total" class="images-dd__list--empty">
                      There are no items on your request
                    </div>
                  </div>

                  <nav class="images-dd__source-nav">
                    <pager
                      :total="total"
                      :offset="offset"
                      :size="perPage"
                      @page-changed="changePage"
                    />
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mb-5">
        <button class="btn btn-success" @click="save">
          Save Tracks
          <span class="btn-loader" style="display: none;" />
        </button>

        <div class="saving-alerts" style="margin-top: 20px;">
          <div class="alert alert-success" style="display: none;">
            Tracks have saved successful!
          </div>
          <div class="alert alert-danger" style="display: none;">
            {{ saveErrorMessage }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import Pager from '@/global/components/Pager';
import SmartImage from '@/global/components/SmartImage';

export default {
  name: 'AlbumAddTracks',

  components: {
    pager: Pager,
    'smart-image': SmartImage,
  },

  data() {
    return {
      searchProcessId: null,
      searchQuery: '',
      total: 0,
      perPage: 0,
      offset: 0,
      sourceTracks: [],
      selectedTracks: [],
      saveErrorMessage: 'Error in data saving',
    };
  },

  watch: {
    searchQuery: _.debounce(function () {
      this.offset = 0;
      this.getSourceTracks();
    }, 400),
    offset() {
      this.getSourceTracks();
    },
  },

  mounted() {
    this.getSourceTracks();
  },

  methods: {
    shortTitle(title) {
      if (title.length > 30) {
        return `${title.slice(0, 30)}...`;
      }
      return title;
    },
    addTrack(track) {
      const index = _.findIndex(this.selectedTracks, item => track.id === item.id);
      if (index === -1) {
        this.selectedTracks.push(track);
      }
    },
    deleteTrack(track) {
      _.remove(this.selectedTracks, item => item.id === track.id);
      this.$forceUpdate();
    },
    getSourceTracks() {
      if (this.$refs.sourceSpinner) { this.$refs.sourceSpinner.show(); }
      const searchString = encodeURI(this.searchQuery);
      const page = this.perPage ? (this.offset / this.perPage + 1) : 1;
      const searchProcessId = Math.random();
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(`${this.$config.app_api.prefix}media/audio?search_string=${searchString}&page=${page}`)
        .then((response) => {
          if (this.searchProcessId === searchProcessId) {
            if (this.$refs.sourceSpinner) { this.$refs.sourceSpinner.hide(); }
            this.total = response.data.meta.pagination.total;
            this.perPage = response.data.meta.pagination.per_page;

            const tracksArr = _.cloneDeep(response.data);
            delete tracksArr.meta;
            this.sourceTracks = tracksArr;
          }
        }).catch((error) => {
          if (this.$refs.sourceSpinner) { this.$refs.sourceSpinner.hide(); }
          console.error(error);
        });
    },
    changePage(offset) {
      this.offset = offset;
    },
    isEntityValid() {
      if (!this.selectedTracks.length) {
        this.errorSave('You should choose at least one audio track');
        return false;
      }
      return true;
    },
    saveRequest() {
      const postFormData = new FormData();
      for (let i = 0; i < this.selectedTracks.length; i += 1) {
        postFormData.append('ids[]', this.selectedTracks[i].id);
      }
      return this.$apiHttp.post(
        `${this.$config.app_api.prefix}media/audio-albums/${this.$route.params.id}/attach/tracks`,
        postFormData,
      );
    },
    save() {
      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      this.saveRequest().then(() => {
        this.successSave();
        this.selectedTracks = [];
        this.$forceUpdate();
      }).catch((error) => {
        this.errorSave('Error in data saving');
        console.error('Error in add tracks to audio album query', error);
      });
    },
    successSave() {
      $('.btn-success .btn-loader').hide();
      $('.saving-alerts .alert-success').show();
    },
    errorSave(errorMessage) {
      $('.btn-success .btn-loader').hide();
      this.saveErrorMessage = errorMessage;
      $('.saving-alerts .alert-danger').show();
    },
  },
};
</script>



// WEBPACK FOOTER //
// AddTracks.vue?3514bf33